import {Capability, type FieldDefinition, type FieldsData} from './fields'

/**
 * The `Array` quantifier deciding how much of the board a field has to cover to be offered.
 * Grouping and attributes take `some`: the server buckets the items an axis does not reach, so
 * their cards are still drawn (github/views#204). Sorting has no such bucket and holds at `every`.
 */
const APPLIES_TO: Record<Capability, 'some' | 'every'> = {
  [Capability.GROUPABLE]: 'some',
  [Capability.ATTRIBUTABLE]: 'some',
  [Capability.SORTABLE]: 'every',
}

/**
 * The fields the view definition declares as supporting `capability`, in declaration order.
 * `APPLIES_TO` decides how many of the board's item types a field must support to qualify.
 */
export function getFieldsForCapability(view: FieldsData, capability: Capability): FieldDefinition[] {
  if (view.itemTypes.length === 0) return []
  const appliesTo = APPLIES_TO[capability]
  return view.fields.filter(field => {
    const supports = (itemType: FieldsData['itemTypes'][number]) =>
      field.capabilities[capability]?.includes(itemType) ?? false
    return view.itemTypes[appliesTo](supports)
  })
}
